'use client';

import DownloadIcon from '@mui/icons-material/Download';
import { Button, CircularProgress } from '@mui/material';
import React, { useState } from 'react';

import { downloadCSVFile } from '../../utils';

interface Props {
	args: any;
	endpoint: string;
	fileName: string;
	userToken: string;
}

export const CsvExportButton = (props: Props): JSX.Element => {
	const { fileName, endpoint, args, userToken } = props;
	const [csvLoading, setCsvLoading] = useState(false);

	const exportAsCsv = async () => {
		setCsvLoading(true);
		fetch(`${process.env.NEXT_PUBLIC_MONTHLY_API_URL + endpoint}`, {
			method: 'POST',
			body: JSON.stringify({ ...args }),
			headers: {
				Authorization: `Bearer ${userToken}`,
			},
		}).then((res) =>
			res
				.text()
				.then((data) => {
					downloadCSVFile(data, fileName);
					setCsvLoading(false);
				})
				.catch((err) => {
					console.log(err);
				}),
		);
	};

	return (
		<Button onClick={exportAsCsv} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
			{' '}
			Export
			{csvLoading ? (
				<CircularProgress style={{ height: '20px', width: '20px' }} />
			) : (
				<DownloadIcon style={{ height: '20px', width: '20px' }} />
			)}
		</Button>
	);
};
